import { GlobalStore } from '../../store/store.service';
/**
 * @deprecated
 */
export function GetStore(name?: string) {
    return function (target, propertyKey) {
        let service = GlobalStore.injector.get(GlobalStore);
        // target[propertyKey] = service.get(name);
    }
}